export default function getResource(label, vars = []) {
    const resources = {
        title: 'Join Sephora Texts',
        illustrationAlt: 'Join Sephora Texts illustration',
        description: 'Enter your mobile phone number below to sign up, and never miss out on exclusive releases, events, and offers.',
        phonePlaceholder: 'Enter Phone Number',
        disclaimer1: 'By entering your phone number, clicking the "Continue" button and confirming sign-up, you consent and agree to receive recurring autodialed marketing texts, including abandoned cart reminders, and confirm that you have read and agree to the',
        disclaimer2: 'Message frequency varies. Consent is not a condition of purchase. Message & data rates may apply. See our',
        and: 'and',
        privacyPolicy: 'PRIVACY POLICY',
        noticeOfFinancialIncentive: 'NOTICE OF FINANCIAL INCENTIVE',
        textTerms: 'TEXT TERMS',
        cancelHelp: 'Text STOP to cancel at any time. HELP for help.',
        cancelButton: 'Cancel',
        continueButton: 'Continue',
        emptyError: 'Please enter a mobile phone number.',
        invalidError: 'Please enter a valid mobile phone number.',
        confirmationTitle: 'Subscribe to Sephora Texts',
        confirmationMessage: 'You\'re so close! A text is on the way.',
        confirmationPhonePrefix: 'We sent it to you at',
        continueShoppingButton: 'Continue Shopping',
        errorMsg: 'Please correct the error(s) in the highlighted fields above. ',
        errorSubmitting: 'Sorry, there was an error submitting your request. Please try again later.'
    };

    return resources[label];
}
